import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
export const catalogIssuesLegacyCanMatch: CanMatchFn = () => {
  const router = inject(Router);
  const url = router.currentNavigation()?.extractedUrl ?? router.parseUrl(router.url);
  return url.queryParams['issueId']
    ? router.createUrlTree(['/app/catalog-issues'], { queryParams: url.queryParams })
    : true;
};
